import { Spinner } from '@insify/ui';

import * as styles from './FullScreenSpinner.module.css';

type Props = { show: boolean };

const FullScreenSpinner: React.VFC<Props> = ({ show }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Spinner size='44px' color='white' />
    </div>
  );
};

export { FullScreenSpinner };
